// Module
var code = `<table class="table" ng-if="vm.rows.length > 0" fixed-table-headers="scrollable-area" ng-table>
    <tr>
        <th>Date</th>
        <th>Installs</th>
        <th
            ng-repeat="name in vm.columnNames"
            uib-tooltip="{{ vm.tooltips[name] }}"
            tooltip-append-to-body="true"
        >{{ name }}</th>
    </tr>
    <tr style="background-color: #FFEBCD">
        <td>Average</td>
        <td>{{ vm.fix_number(vm.rows[0].install_count) }}</td>
        <td ng-repeat="name in vm.columnNames">{{ vm.rows[0].columns[name] }}</td>
    </tr>
    <tr ng-repeat="row in vm.rows.slice(1, vm.rows.length)">
        <td class="nowrap">
            <div ng-if="!vm.getPlayers">{{ row.install_date }}</div>
            <a ng-if="vm.getPlayers" ui-sref="{{ vm.getPlayers }}({date: row.install_date})">{{ row.install_date }}</a>
        </td>
        <td>{{ vm.fix_number(row.install_count) }}</td>
        <td ng-repeat="name in vm.columnNames" ng-style="{'background-color': vm.get_bg_color(row.columns[name], name)}">
            {{ vm.fix_number(row.columns[name]) }}
        </td>
    </tr>
</table>
`;
// Exports
module.exports = code;